/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Customer_Refund_SubmitInputs */

const vi_customer_refund_submit = /** @type {(inputs: Customer_Refund_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lập phiếu hoàn tiền`)
};

/**

* @param {Customer_Refund_SubmitInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const customer_refund_submit = /** @type {((inputs?: Customer_Refund_SubmitInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Customer_Refund_SubmitInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_customer_refund_submit(inputs)
});